export const TRANSACTION_ID = 'transaction';
export const SALES_DASHBORAD = 'report_dashboard';
export const CONTACT_US = 'contact_us';
export const DETAILS = 'details';
